package one.healthium.data.user.dto

import dev.gitlive.firebase.firestore.Timestamp
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
internal data class FoodPhotoQuotaDto(
    @SerialName("limit") val limit: Int? = null,
    @SerialName("remaining") val remaining: Int? = null,
    @SerialName("reset_at") val resetAt: Timestamp? = null,
)
